export class FetchExternalValueDefinitionError extends Error {
  constructor(url: string) {
    super(`Failed to fetch value definition from: ${url}`);
    this.name = 'FetchExternalValueDefinitionError';
  }
}
